import { schema } from 'normalizr';

const attachmentSchema = new schema.Entity('attachments', {});

export default attachmentSchema;
